import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Network from "./Network";

const TOTAL_SECONDS = 10;

function RedirectWithCountdown({ url }) {
  const [countdown, setCountdown] = useState(TOTAL_SECONDS);

  const fullUrl = /^https?:\/\//i.test(url) ? url : "https://" + url;

  let displayDomain;
  try {
    displayDomain = new URL(fullUrl).hostname;
  } catch {
    displayDomain = url;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => (prev <= 1 ? 0 : prev - 1));
    }, 1000);

    const timeout = setTimeout(() => {
      window.location.href = fullUrl;
    }, TOTAL_SECONDS * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [fullUrl]);

  const progress = ((TOTAL_SECONDS - countdown) / TOTAL_SECONDS) * 100;

  return (
    <div className="redirect-page">
      <div className="redirect-card">
        <div className="redirect-card__logo">
          <img src="/starlinks.io.logo.svg" alt="" />
          starlinks.io
        </div>

        <h1 className="redirect-card__title">Redirecting you securely</h1>
        <p className="redirect-card__subtitle">You will be redirected to your destination shortly.</p>

        <div className="progress-bar" role="progressbar" aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">
          <div className="progress-bar__fill" style={{ width: `${progress}%` }} />
        </div>

        <p className="redirect-card__countdown">
          {countdown} second{countdown !== 1 ? "s" : ""} remaining
        </p>

        <p className="redirect-card__destination">{displayDomain}</p>

        <a href={fullUrl} className="btn btn--primary btn--full">
          Continue now
        </a>
      </div>
    </div>
  );
}

const FindUrl = () => {
  const { shortcut } = useParams();
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const domain = window.location.hostname;

    const fetchUrl = async () => {
      try {
        const response = await Network.getUrl(domain, shortcut);
        if (response && response.link) {
          setLink(response.link);
        } else {
          setLink("https://starlinks.io");
        }
      } catch {
        setLink("https://starlinks.io");
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [shortcut]);

  if (loading) {
    return (
      <div className="redirect-page">
        <div className="redirect-loading">
          <div className="redirect-loading__spinner" aria-label="Loading" />
          <p className="redirect-loading__text">Loading…</p>
        </div>
      </div>
    );
  }

  if (link) {
    return <RedirectWithCountdown url={link} />;
  }

  return null;
};

export default FindUrl;
